var generic = generic || {};
var MantleWindow = MantleWindow || {};

(function ($) {
  Drupal.behaviors.productDetailItem = {
    attach: function (context) {
      var $items = $('.js-product-detail-item', context);

      $items.each(function (i, obj) {
        var $item = $(obj);
        var $textContainer = $('.product-detail-item__text', $item);
        var $textContent = $('.product-detail-item__text-inner', $item);
        var $arrows = $('.arrows', $item);
        var $up_arrow = $('.up-arrow', $item);
        var $down_arrow = $('.down-arrow', $item);
        var scrollDelta = 20;
        var mobileScrollBehavior = $item.data('mobile-scroll-behavior');

        if (!mobileScrollBehavior) {
          mobileScrollBehavior = 'expand';
        }

        var arrowsScrollOnMobile = true;

        if (mobileScrollBehavior === 'overlay' || mobileScrollBehavior === 'expand') {
          arrowsScrollOnMobile = false;
        }

        var _render_arrows = function () {
          var container_height = $textContainer.height();
          var text_height = $textContent.outerHeight(false);
          var scrollable = text_height > container_height;

          if (!scrollable) {
            $arrows.addClass('arrows--hidden');

            return;
          }
          $arrows.removeClass('arrows--hidden');
          var scroll_top = $textContainer.scrollTop();
          var at_top = scroll_top === 0;
          var at_bottom = scroll_top + container_height >= text_height;

          if (at_top) {
            $arrows.addClass('at-top');
            $up_arrow.removeClass('active');
          } else {
            $arrows.removeClass('at-top');
            $up_arrow.addClass('active');
          }
          if (at_bottom) {
            $down_arrow.removeClass('active');
            $arrows.addClass('at-bottom');
          } else {
            $down_arrow.addClass('active');
            $arrows.removeClass('at-bottom');
          }
        };
        // setup for overlay
        var $readMoreText = $textContainer;
        var popup_readmore = function (e) {
          e.preventDefault();
          var $target = $(e.target);
          var $section = $target.closest('.product-details__section');
          var detail_type = $section.data('detail-type');
          var $title = $('.product-details__menu-title[data-detail-type="' + detail_type + '"]');
          var options = {
            content:
              '<h2 class="product-details__menu-title">' +
              $title.html() +
              '</h2>' +
              $readMoreText.prop('outerHTML'),
            cssClass: 'readmore-popup readmore-popup--' + detail_type
          };
          var top = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);

          $('body').data('old-top', top);
          $('body').addClass('modal-open');
          $('body').css('margin-top', -top + 'px');
          generic.overlay.launch(options);
          $('#cboxClose').on('click', function (e) {
            $('body').removeClass('modal-open');
            var old_top = $('body').data('old-top');

            $('body').css('margin-top', 0);
            window.scrollTo(0, old_top);
            e.preventDefault();
          });
          $('.overlay-background')
            .once('hideOnOutsideClick')
            .on('click', function () {
              $('body').removeClass('modal-open');
              var old_top = $('body').data('old-top');

              $('body').css('margin-top', 0);
              window.scrollTo(0, old_top);
              generic.overlay.hide();
            });
        };
        var original_height = $textContainer.height();
        var inline_expand = function (e) {
          if ($item.data('animating-text')) {
            return;
          }

          if ($item.hasClass('product-detail-item--text-expanded')) {
            $item.data('animating-text', true);
            $textContainer.animate(
              {
                height: original_height
              },
              {
                complete: function () {
                  $item.data('animating-text', false);
                  $item.removeClass('product-detail-item--text-expanded');
                }
              }
            );

            return;
          }

          $item.addClass('product-detail-item--text-expanded');
          $item.data('animating-text', true);
          $textContainer.animate(
            {
              height: 'auto'
            },
            {
              complete: function () {
                $textContainer.height('auto');
                $item.data('animating-text', false);
              }
            }
          );
          e.preventDefault();
        };
        var is_mobile = function () {
          var breakpoint = Unison.fetch.now();
          var isMobile = breakpoint.name === 'small';

          return isMobile;
        };
        var is_tablet = function () {
          var breakpoint = Unison.fetch.now();
          var isTablet = breakpoint.name === 'medium';

          return isTablet;
        };

        // update arrows on scroll
        $textContainer.on(
          'scroll',
          _.debounce(function () {
            _render_arrows();
          }, 200)
        );

        function scrollDown() {
          if (is_mobile() && !arrowsScrollOnMobile) {
            return;
          }
          var current = $textContainer.scrollTop();

          $textContainer.scrollTop(current + scrollDelta);
        }

        function scrollUp() {
          if (is_mobile() && !arrowsScrollOnMobile) {
            return;
          }
          var current = $textContainer.scrollTop();

          $textContainer.scrollTop(current - scrollDelta);
        }

        function attach_arrow_handler($arrow, _func) {
          var mouseDownInterval;
          var scroll_func = _func;

          $arrow.on('touchstart mousedown', function (e) {
            var that = $(this);

            if (mouseDownInterval) {
              clearInterval(mouseDownInterval);
            }
            if (e.type == 'mousedown' && e.button != 0) {
              return;
            }

            if (is_mobile() && mobileScrollBehavior == 'overlay') {
              popup_readmore(e);

              return;
            }

            if ((is_mobile() || is_tablet()) && mobileScrollBehavior == 'expand') {
              inline_expand(e);

              return;
            }

            e.preventDefault();
            mouseDownInterval = window.setInterval(function () {
              scroll_func();
              _render_arrows();
              // using _render_arrows to see if we're at edge
              if (!that.hasClass('active')) {
                clearInterval(mouseDownInterval);
              }
            }, 100);
          });

          $arrow.on('mouseup touchend', function (e) {
            scroll_func();
            if (mouseDownInterval) {
              clearInterval(mouseDownInterval);
            }
          });
        }

        attach_arrow_handler($up_arrow, scrollUp);
        attach_arrow_handler($down_arrow, scrollDown);

        MantleWindow.onResizeWidth(_render_arrows, null, 200);

        _render_arrows();
      });
    }
  };
})(jQuery);
